export default function clearHospitals(hospitals) {
  return hospitals.map((hospital) => {
    const { address, __typename, ...rest } = hospital;
    return {
      ...rest,
    };
  });
}
